<template>
    <div class="action-type-buttons">
        <div class="item-title">I would like to</div>

        <div class="actions-list">
            <button
                v-for="action in actions"
                :key="action.key"
                :class="['action', { selected: selected === action.key }]"
                @click="updateAction(action.key)"
                @keydown.enter="updateAction(action.key)"
            >
                {{ action.text }}
            </button>
        </div>
    </div>
</template>

<script>
import { Actions } from '@/services/enums';

export default {
    name: 'ActionTypeButtons',

    props: {
        selected: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            actions: [
                { key: Actions.Call, text: 'Schedule a call' },
                {
                    key: Actions.RemoteAppointment,
                    text: 'Request a remote appointment',
                },
                {
                    key: Actions.DealershipAppointment,
                    text: 'Schedule a dealership appointment',
                },
                { key: Actions.Question, text: 'Ask a question' },
            ],
        };
    },

    methods: {
        updateAction(actionKey) {
            const query = { ...this.$route.query, action: actionKey };
            this.$router.replace({ query });
        },
    },
};
</script>

<style lang="scss" scoped>
.action-type-buttons {
    margin-top: 2rem;
    padding: 0 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .item-title {
        font-weight: $font-weight-semibold;
        font-size: 20px;
        letter-spacing: 0px;
        color: $color-highlight;
    }

    .actions-list {
        margin-top: 1rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;

        .action {
            flex: auto;
            user-select: none;
            text-align: center;
            font-size: $font-size-base;
            color: $color-medium-gray;
            padding: 1rem 2rem;
            border: 1px solid $color-light-gray;
            border-radius: $rounded;
            margin: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            cursor: pointer;
            transition: $transition;
            background-color: transparent;

            &:hover {
                background-color: $color-very-light-gray;
            }

            &.selected {
                background-color: $color-highlight;
                border-color: $color-highlight;
                color: $color-font-light;
            }
        }
    }
}
</style>
